// @ts-check
import React from 'react';

/**
 * Stores the reference to the clicked node.
 * @returns {[Element | null, boolean, (event: MouseEvent) => void, () => void]}
 */
export const useMenuRef = () => {
  /** @type {[Element | null, Function]} */
  const [menuAnchorEl, setMenuAnchorEl] = React.useState(null);

  const isMenuOpen = !!menuAnchorEl;

  /** @param {MouseEvent} event */
  const open = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const close = () => {
    setMenuAnchorEl(null);
  };

  return [menuAnchorEl, isMenuOpen, open, close];
};

export default useMenuRef;
